
import { getTokenLine, testMessagingLine, updateTokenLine } from 'services/lineApi'
import {
    GetNotificatioInput, GetNotificationResponse, GetTokenLineResponse, TestMessagingResponse, UpdateLineTokenInput, UpdateLineTokenResponse, UpdateNotificatioInput, UpdateNotificationResponse
} from 'services/interface'
import { getNotification, updateReadNotification } from 'services/notificationApi'
import { UseQueryResult, useQuery, UseMutationResult, useMutation } from '@tanstack/react-query'
// Get Token Line
export const useGetTokenLine = (): UseQueryResult<GetTokenLineResponse, Error> => {
  return useQuery<GetTokenLineResponse, Error>({
    queryKey: ['getTokenLine'],
    queryFn: () => getTokenLine(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}

// Update Token Line
export const useUpdateTokenLine = (): UseMutationResult<
  UpdateLineTokenResponse,
  Error,
  UpdateLineTokenInput,
  unknown
> => {
  return useMutation<UpdateLineTokenResponse, Error, UpdateLineTokenInput, unknown>({
    mutationFn: (input: UpdateLineTokenInput) => updateTokenLine(input),
  })
}

// Test Messaging Line
export const useTestMessagingLine = (): UseQueryResult<TestMessagingResponse, Error> => {
  return useQuery<TestMessagingResponse, Error>({
    queryKey: ['testMessagingLine'],
    queryFn: () => testMessagingLine(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}
